// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3k28D{padding-left:20px;padding-right:20px;padding-top:100px}._2CBp_{margin:0 auto;padding:0 0 40px;max-width:1000px}", ""]);
// Exports
exports.locals = {
	"root": "_3k28D",
	"container": "_2CBp_"
};
module.exports = exports;
